import { render, staticRenderFns } from "./ModalErrorDepartamento.vue?vue&type=template&id=3a88128a&"
import script from "./ModalErrorDepartamento.vue?vue&type=script&lang=js&"
export * from "./ModalErrorDepartamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports